import React from "react";
import { CodeIcon } from "@heroicons/react/solid";

const ChatRoom = () => {
  const iframeSrc = "https://deadsimplechat.com/XlL4svXLY";
  return (
    <React.Fragment>
      <div className="flex flex-col w-full mb-20 text-center">
        <CodeIcon className="mx-auto inline-block w-10 mb-4" />
        <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
          Text Chat
        </h1>
        <p className="lg:w-2/3 mx-auto leading-relaxed text-base p-4">
          This is a text chat app that uses a third-party service for real-time communication. 
          Click "Join Chat" to start a chat session with me if you are an interested party looking
          for a technical CSM. This is app is for demo purposes only, so please be respectful when using it. 
          There is a password to enter the private chat with me, it is "Robert's Chatroom Demo".
        </p>
      </div>

      <div style={{ margin: "0 auto", width: "65%" }}>
        <iframe
          title="chat-room"
          src={iframeSrc}
          width="100%"
          height="650"
          style={{ border: "none", margin: "0", padding: "0" }}
        ></iframe>
      </div>
    </React.Fragment>
  );
};

export default ChatRoom;



// WEBPACK FOOTER //
// ./src/components/ChatRoom.js